const { withReduxProvider } = require('utils/framework/wrapWithReduxProvider');
const InflateComponents = require('utils/framework/InflateComponents');
const withRootComponentProps = require('utils/framework/withRootComponentProps');

Sephora.Util.InflatorSPA = {};
const ErrorBoundaryComponentName = 'ErrorBoundary(';
const RenderTimeMeasurementsComponentName = '(RenderTimeMeasurements(';
const HOCWrappingIsDisabled = Sephora.configurationSettings.core.disableHOCWrapping === true;

const createDisplayNameAsForSSR = component => {
    const { displayName } = component;
    let counter = -1;
    let length = 0;
    let ssrDisplayName = displayName
        .split(RenderTimeMeasurementsComponentName)
        .reduce((total, item) => {
            const result = `${total}(${item}`;
            counter++;
            length = result.length;

            return result;
        }, '')
        .substring(1, length - counter);

    if (ssrDisplayName.startsWith(ErrorBoundaryComponentName)) {
        ssrDisplayName = ssrDisplayName.substring(ErrorBoundaryComponentName.length, ssrDisplayName.length - 1);
    }

    if (HOCWrappingIsDisabled) {
        ssrDisplayName = `ReduxProvider(${ssrDisplayName})`;
    } else {
        ssrDisplayName = `ErrorBoundary(ReduxProvider(${ssrDisplayName}))`;
    }

    return ssrDisplayName;
};

const renderRootComponent = component => {
    const displayName = createDisplayNameAsForSSR(component);
    const element = document.body.querySelector(`[rootid="${displayName}"]`);

    if (element) {
        const componentWithProps = withReduxProvider(withRootComponentProps(component, displayName));
        InflateComponents.render(componentWithProps, null, element);
    }
};

// require.ensure is used to package nested requires in components.chunk.js
// rather than priority.bundle.js in order to keep priority.bundle.js lean
const renderRootComponents = () =>
    require.ensure(
        [],
        require => {
            const SpaUtils = require('utils/Spa');
            const Header = require('components/Header/Header');
            const GlobalModalsWrapper = require('components/GlobalModals/GlobalModalsWrapper/GlobalModalsWrapper');
            const GlobalContent = require('components/GlobalContent/GlobalContent');
            const isSpaPage = SpaUtils.isSpaTemplate(Sephora.renderedData.template);
            let Page;

            if (isSpaPage) {
                Page = require('../../SpaApplication');
            } else {
                Page = require('pages/' + Sephora.renderedData.template);
            }

            renderRootComponent(Header);
            renderRootComponent(Page);
            renderRootComponent(GlobalModalsWrapper);
            renderRootComponent(GlobalContent);

            Sephora.Util.InflatorComps.services.loadEvents.HydrationFinished = true;
            const { HydrationFinished } = require('utils/framework/Events');
            window.dispatchEvent(new CustomEvent(HydrationFinished));
            Sephora.Util.Perf.report(HydrationFinished);
        },
        'components'
    );

// require.ensure is used to package nested requires in postload.chunk.js
// rather than priority.bundle.js or components.chunk.js in order to keep them lean
const renderPostLoadRootComponents = () =>
    require.ensure(
        [],
        () => {
            Sephora.Util.Perf.report('PostLoad Ready');

            const Footer = require('components/Footer');
            const { PostloadedGAdTagList } = require('components/GAdTag');
            const SmartChat = require('components/SmartChat');
            const { PostLoad } = require('utils/framework/Events');

            InflateComponents.services.loadEvents[PostLoad] = true;
            window.dispatchEvent(new CustomEvent(PostLoad));

            renderRootComponent(Footer);
            renderRootComponent(PostloadedGAdTagList);
            renderRootComponent(SmartChat);

            Sephora.Util.Perf.report('Post Load Rendered');
        },
        'postload'
    );

module.exports = {
    renderPostLoadRootComponents,
    renderRootComponents
};
